import React, { useState, useEffect } from 'react';
import { Button } from './ui/Button';
import { Logo } from './ui/Logo';

export const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavigation = (id?: string) => {
    const pageContent = document.getElementById('page-content');
    
    // 1. Trigger "Jump Out" Animation
    pageContent?.classList.add('navigating');

    // 2. Wait for animation to establish, then scroll
    setTimeout(() => {
        if (id) {
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            // Scroll to top if no ID (Logo click)
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }

        // 3. Trigger "Jump In" Animation after scroll starts
        setTimeout(() => {
            pageContent?.classList.remove('navigating');
        }, 500);

    }, 350);
  };

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'bg-black/90 backdrop-blur-md border-b border-white/10 py-2 md:py-4' : 'bg-transparent py-2 md:py-6'
      }`}
    >
      {/* 
         Mobile Layout: Flex Column (Stack)
         Desktop Layout: Flex Row (Standard)
      */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 relative flex flex-col md:flex-row items-center md:justify-between gap-2 md:gap-0 min-h-[auto] md:min-h-[48px]">
        
        {/* Placeholder sinistro Desktop (Balance) */}
        <div className="hidden md:block w-[180px]" />

        {/* 
            Logo Container
            Mobile: Order 2 (Bottom), Static Position
            Desktop: Order None, Absolute Center
        */}
        <div className="order-2 md:order-none relative md:absolute md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2 z-[60] mt-1 md:mt-0">
            <a 
                href="#" 
                className="flex items-center gap-2 group" 
                onClick={(e) => { e.preventDefault(); handleNavigation(); }}
            >
              {/* Logo custom SVG, ruota all'hover */}
              <div className="p-1 md:p-2 bg-transparent text-white group-hover:rotate-12 transition-transform">
                <Logo className="w-8 h-8 md:w-10 md:h-10" />
              </div>
              <span className="text-sm md:text-xl font-bold tracking-tighter text-white whitespace-nowrap">MOON DIGITAL AGENCY</span>
            </a>
        </div>

        {/* 
            CTA Container
            Mobile: Order 1 (Top), Full Width/Centered
            Desktop: Order None, Right Aligned
        */}
        <div className="order-1 md:order-none w-full md:w-auto flex justify-center md:block ml-auto md:ml-0 z-[60]">
          <Button 
            variant="primary" 
            className="!w-full md:!w-auto !px-4 !py-2 md:!px-6 md:!py-2 text-[10px] md:text-sm font-bold whitespace-nowrap h-8 md:h-auto"
            onClick={() => handleNavigation('contact')}
          >
            Prendi appuntamento
          </Button>
        </div>
      </div>
    </nav>
  );
};